"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _utils = require("./utils");

var _Button = _interopRequireDefault(require("@insided/shared/uikit/Button"));

var _assets = _interopRequireDefault(require("../../preact-components/assets"));

var _CategoryFilterSelector = _interopRequireDefault(require("@insided/deprecated-control/overview/filters/CategoryFilterSelector"));

var DashboardCategoryFilter = function DashboardCategoryFilter(_ref) {
  var id = _ref.id,
      name = _ref.name,
      customClassName = _ref.customClassName,
      title = _ref.title,
      isDropdownOpen = _ref.isDropdownOpen,
      toggleDropdown = _ref.toggleDropdown,
      resetDropdown = _ref.resetDropdown,
      categoriesV2 = _ref.categoriesV2,
      selectedItems = _ref.selectedItems,
      onClear = _ref.onClear,
      onChange = _ref.onChange,
      isLoading = _ref.isLoading;
  var placeholderAdditionalText = (0, _utils.getCategoryPlaceholder)(categoriesV2, selectedItems);

  var getApplyAndCancelButtons = function getApplyAndCancelButtons(_ref2) {
    var isApplyButtonDisabled = _ref2.isApplyButtonDisabled,
        data = _ref2.data;
    return (0, _preact.h)("div", null, (0, _preact.h)("hr", null), (0, _preact.h)("div", {
      className: "overview__filters-box-buttons"
    }, (0, _preact.h)(_Button.default, {
      size: "small",
      variant: "brand",
      title: "Apply",
      disabled: isApplyButtonDisabled,
      onClick: function onClick() {
        return onChange(data);
      },
      "data-element-name": "Category apply button",
      "data-track-type": "click"
    }), (0, _preact.h)(_Button.default, {
      size: "small",
      title: "Cancel",
      onClick: resetDropdown,
      "data-element-name": "Category cancel button",
      "data-track-type": "click"
    })));
  };

  return (0, _preact.h)("div", {
    className: "filter-option filter-option-".concat(customClassName)
  }, (0, _preact.h)(_Button.default, {
    disabled: isLoading,
    title: (0, _preact.h)(FilterTitle, {
      title: title,
      onClear: onClear,
      isDropdownOpen: isDropdownOpen,
      placeholder: placeholderAdditionalText,
      selectedItems: selectedItems
    }),
    size: "medium",
    className: "".concat(customClassName, "-open-button filter-option-button ").concat(isDropdownOpen ? 'dropdown-open' : '', " "),
    onClick: function onClick() {
      return toggleDropdown(!isDropdownOpen);
    },
    "data-element-name": "Category filter button",
    "data-track-type": "click"
  }), isDropdownOpen && (0, _preact.h)("div", {
    className: "overview__filters-box-container"
  }, (0, _preact.h)("div", {
    className: "overview__filters-box"
  }, categoriesV2 && (0, _preact.h)(_CategoryFilterSelector.default, {
    id: id,
    name: name,
    items: categoriesV2,
    selectedFilterItems: selectedItems,
    disableApplyButton: false
  }, getApplyAndCancelButtons))));
};

var FilterTitle = function FilterTitle(_ref3) {
  var title = _ref3.title,
      placeholder = _ref3.placeholder,
      onClear = _ref3.onClear,
      selectedItems = _ref3.selectedItems,
      isDropdownOpen = _ref3.isDropdownOpen;
  return (0, _preact.h)("div", {
    className: "dropdown-filter-title"
  }, (0, _preact.h)("div", {
    className: "dropdown-placeholder-text ".concat(isDropdownOpen ? 'filter-dropdown-open' : '')
  }, " ", title), (0, _preact.h)("div", {
    className: "dropdown-selected-placeholder ".concat(isDropdownOpen ? 'filter-dropdown-open' : '')
  }, placeholder === null || placeholder === void 0 ? void 0 : placeholder.text), (placeholder === null || placeholder === void 0 ? void 0 : placeholder.additionalText) && (0, _preact.h)("div", {
    className: "dropdown-selected-placeholder-additional-text ".concat(isDropdownOpen ? 'filter-dropdown-open' : '')
  }, placeholder === null || placeholder === void 0 ? void 0 : placeholder.additionalText), selectedItems.length > 0 ? (0, _preact.h)("div", {
    className: "icon-cancel-wrapper",
    onClick: function onClick(e) {
      return onClear(e);
    }
  }, (0, _preact.h)(_assets.default, {
    icon: "cancel",
    customClass: "icon-cancel",
    height: 16,
    width: 16
  }), ' ') : null);
};

var _default = DashboardCategoryFilter;
exports.default = _default;